// NProgressHandler.js
import { useEffect } from "react";
import { useNavigationType, useLocation } from "react-router-dom";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({
    showSpinner: false,
    trickleSpeed: 120,
    minimum: 0.1
});

const NProgressHandler = () => {
    const location = useLocation();
    const navType = useNavigationType();

    useEffect(() => {
        if (navType === "PUSH" || navType === "POP") {
            NProgress.start();
        }

        return () => {
            NProgress.done();
        };
    }, [location]);

    return null;
};

export default NProgressHandler;
